import classNames from "classnames";

type QAWrapperTKProps = {
  id?: string;
  children: any;
  customClassName?: string;
};

/**
 * This is a simple div element to wrap some Toyota Kit components which need to be targeted by QA for testing.
 * Since most Toyota Kit components do not accept extra properties, this wrapper is an alternative approach to attach the QA ID
 * as close to the target element as possible.
 *
 * @param {QAWrapperTKProps} props
 * @param {string} props.id - The QA ID. Refer to the ID constants in /src/_common/modules/Data/static.ts for QA IDs.
 * @param {any} props.children - Any element(s) placed within this component.
 * @param {string} props.customClassName - An optional class name for styling purposes.
 *
 * @returns A div element with an optional data attribute [data-qa] containing the ID to be used by QA for testing,
 * and an optional data-button-name attribute for tracking GA events.
 */
const QAWrapperTK = ({ id, children, customClassName }: QAWrapperTKProps) => {
  const getClassName = () => classNames("QAWrapperTK", customClassName);

  const getDataAttributes = () => ({
    ...(id && { "data-qa": id }),
  });

  return (
    <div className={getClassName()} {...getDataAttributes()}>
      {children}
    </div>
  );
};

export default QAWrapperTK;
